import { render, staticRenderFns } from "./PersonalInformationForm.vue?vue&type=template&id=661e9f12&"
import script from "./PersonalInformationForm.vue?vue&type=script&lang=js&"
export * from "./PersonalInformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports